"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _icon_wrapper = _interopRequireDefault(require("./icon_wrapper"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var UnknownUserIcon = /*#__PURE__*/function (_React$Component) {
  function UnknownUserIcon() {
    _classCallCheck(this, UnknownUserIcon);
    return _callSuper(this, UnknownUserIcon, arguments);
  }
  _inherits(UnknownUserIcon, _React$Component);
  return _createClass(UnknownUserIcon, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement("svg", {
        className: "unknown-user icon",
        xmlns: "https://www.w3.org/2000/svg",
        version: "1.1",
        x: "0px",
        y: "0px",
        viewBox: "0 0 512 640"
      }, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("rect", {
        x: "144",
        y: "442",
        width: "40",
        height: "12"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "64",
        y: "442",
        width: "40",
        height: "12"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M167.884,234.935c-7.081-10.562-12.146-22.17-15.055-34.501l-11.68,2.756c3.241,13.736,8.882,26.665,16.767,38.427    L167.884,234.935z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M162.03,126.904l-10.631-5.566c-6.554,12.517-10.759,25.979-12.498,40.01l11.909,1.476    C152.372,150.226,156.146,138.141,162.03,126.904z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M81.849,329.096l10.107,6.469c6.788-10.605,15.187-20.312,24.965-28.849l-7.893-9.039    C98.395,306.961,89.25,317.532,81.849,329.096z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M348.112,123.508l10.42-5.951c-6.998-12.252-16.047-23.063-26.897-32.132l-7.696,9.207    C333.691,102.783,341.824,112.499,348.112,123.508z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M76.231,370.313l-11.517-3.372c-3.743,12.785-5.944,26.515-6.543,40.811l11.989,0.502    C70.719,394.93,72.762,382.164,76.231,370.313z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M371.762,198.982c1.486-7.522,2.239-15.254,2.238-22.982c0-6.337-0.507-12.7-1.508-18.911l-11.848,1.909    C361.544,164.58,362,170.3,362,176.001c0.001,6.949-0.675,13.898-2.01,20.656L371.762,198.982z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M356.419,237.991l-10.205-6.313c-6.674,10.789-15.143,20.216-25.17,28.02l7.37,9.47    C339.57,260.485,348.992,249.996,356.419,237.991z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "304",
        y: "442",
        width: "40",
        height: "12"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M420.358,315.598l-9.288,7.598c8.07,9.866,14.664,20.86,19.597,32.677l11.073-4.623    C436.359,338.359,429.165,326.364,420.358,315.598z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "384",
        y: "442",
        width: "40",
        height: "12"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M353.648,267.741l-4.545,11.105c12.354,5.056,23.756,11.242,33.89,18.387l6.914-9.808    C379.036,279.761,366.837,273.139,353.648,267.741z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M452.402,391.289l-11.895,1.584C441.498,400.31,442,408.091,442,416v16h12v-16    C454,407.563,453.462,399.249,452.402,391.289z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M253.856,58.019l0.217,11.998C254.713,70.005,255.356,70,256,70c12.092,0,23.949,2.018,35.24,5.998l3.988-11.318    C282.652,60.248,269.454,58,256,58C255.284,58,254.569,58.006,253.856,58.019z"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M177.106,88.25l8.026,8.921c9.458-8.51,20.228-15.18,32.009-19.824l-4.401-11.164    C199.623,71.355,187.633,78.779,177.106,88.25z"
      }), /*#__PURE__*/_react["default"].createElement("rect", {
        x: "224",
        y: "442",
        width: "40",
        height: "12"
      }), /*#__PURE__*/_react["default"].createElement("path", {
        d: "M143.362,274.617l5.466,10.683c11.067-5.662,23.219-10.377,36.12-14.016l-3.258-11.55    C168.029,263.587,155.133,268.595,143.362,274.617z"
      }))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _icon_wrapper["default"])(UnknownUserIcon);